import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper/types";
import { A11y, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import ArrowRightIcon from "../../../../shared-components/icons/ArrowRightIcon";
import { useIsMobile } from "../../../../redux/features/device/selectors";
import { useSubscriptionCompetitionsPrizesPageContext } from "../context";

const TopSlider = () => {
  const { competitionDetails, isCompetitionDetailsLoading } = useSubscriptionCompetitionsPrizesPageContext();
  const isMobile = useIsMobile();

  const swiperRef = useRef<SwiperType>(null);
  const nextBtnRef = useRef<HTMLButtonElement>(null);
  const prevBtnRef = useRef<HTMLButtonElement>(null);
  const BtnSwiperClasses =
    "absolute z-[1] top-1/2 -translate-y-1/2 flex items-center justify-center bg-white size-10 rounded-lg";

  return (
    <div className="w-full carousel-container-within-slide-navigation">
      {isCompetitionDetailsLoading ? (
        <div className={"w-full bg-[#F5F5F5] aspect-[900/480]"} />
      ) : (
        <>
          <div className="w-full relative bg-[#F5F5F5]">
            <Swiper
              modules={[Navigation, A11y]}
              slidesPerView={1}
              loop={false}
              spaceBetween={0}
              navigation={
                !isMobile && {
                  nextEl: nextBtnRef.current,
                  prevEl: prevBtnRef.current,
                  disabledClass: "pointer-none !opacity-50",
                }
              }
              onSwiper={swiper => (swiperRef.current = swiper)}
              className="w-full">
              {competitionDetails.promoHeaderImageUrls.map((item, index) => (
                <SwiperSlide key={`banner_${index}`}>
                  <div className="w-full h-full flex overflow-hidden relative aspect-[900/480]">
                    <img src={item} alt={item} className="size-full object-cover" loading="lazy" />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {!isMobile && (
              <>
                {/* Prev */}
                <button
                  ref={prevBtnRef}
                  onClick={() => swiperRef.current?.slidePrev()}
                  className={`topslider-prev-btn left-6 ${BtnSwiperClasses}`}>
                  <ArrowRightIcon className={"size-6 shrink-0 text-black rotate-180"} />
                </button>

                {/* Next */}
                <button
                  ref={nextBtnRef}
                  onClick={() => swiperRef.current?.slideNext()}
                  className={`topslider-next-btn right-6 ${BtnSwiperClasses}`}>
                  <ArrowRightIcon className={"size-6 shrink-0 text-black"} />
                </button>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default TopSlider;
